import React, { useContext, useEffect } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Typography, Box, Button, useMediaQuery } from '@material-ui/core';
import { CHARTER } from 'constants/constant';
import { FEATURES } from 'helper/basicFeatureFlag';
import { UserPortalContext } from 'context/appcontext';
import reportSettingStyles from './ReportSettings.style';

function DynamicScheduling({ isCustomDS, setIsDynamicSelected }) {
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = reportSettingStyles({ isSmallScreen });
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const { DYNAMIC_SCHEDULE_AVAILABLE: dynamicScheduleAvailable } =
		FEATURES[customerType].REPORT_SETTINGS_PAGE;
	const [value, setValue] = React.useState('dynamic');
	const [disableDynamicOption, setDisableDynamicOption] = React.useState(false);

	const handleChange = (event) => setValue(event.target.value);

	useEffect(() => {
		if (value === 'dynamic') {
			setIsDynamicSelected(true);
		} else {
			setIsDynamicSelected(false);
		}
	}, [value]);

	useEffect(() => {
		// For Non CHARTER users, dynamic schedule is not available
		// The dynamic-schedule radio box will be disabled, and fixed will be selected as default
		if (customerType !== CHARTER && !dynamicScheduleAvailable) {
			setValue('fixed');
			setDisableDynamicOption(true);
		}
	}, [customerType, dynamicScheduleAvailable]);

	return (
		<FormControl component="fieldset" style={{ paddingLeft: 16, marginTop: 24, marginBottom: 16 }}>
			<FormLabel component="legend" className={classes.fontStyleOne} style={{ paddingBottom: 8 }}>
				Deliver Time
			</FormLabel>
			<RadioGroup
				aria-label="dynamic-schedule"
				name="dynamic-schedule"
				value={value}
				onChange={handleChange}>
				<FormControlLabel
					value="dynamic"
					className={classes.radio}
					disabled={disableDynamicOption || isCustomDS}
					control={<Radio color="primary" tabIndex="0" />}
					label={
						<Box style={{ display: 'flex', flexDirection: 'column' }}>
							<Box style={{ display: 'flex', alignItems: 'center' }}>
								<Typography>Dynamic: Deliver report after data refreshed</Typography>
								<Button
									style={{
										backgroundColor: '#EBE8F3',
										color: '#3C228A',
										fontWeight: 800,
										fontSize: 12,
										marginLeft: 16
									}}>
									Recommended
								</Button>
							</Box>
						</Box>
					}
				/>
				<Typography style={{ marginLeft: 32, fontSize: 12, color: '#6D6E71' }}>
					Always receive report with the latest data.{' '}
				</Typography>
				<FormControlLabel
					value="fixed"
					className={classes.radio}
					control={<Radio color="primary" tabIndex="0" />}
					label={
						<Box style={{ display: 'flex', flexDirection: 'column' }}>
							<Box style={{ display: 'flex', alignItems: 'center' }}>
								<Typography>Fixed: Deliver report at customized schedule</Typography>
							</Box>
						</Box>
					}
				/>
				<Typography style={{ marginLeft: 32, fontSize: 12, color: '#6D6E71' }}>
					Note:If data refresh isn’t completed by chosen time, report will be sent with the most
					recent available data.
				</Typography>
			</RadioGroup>
		</FormControl>
	);
}

export default DynamicScheduling;

//Note:If data refresh isn’t completed by chosen time,  report will be sent with the most recent available data.
